var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle64C = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M22.5 58.003a2.5 2.5 0 0 1-2.5-2.5v-31a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v31a2.5 2.5 0 0 1-2.5 2.5h-15ZM54 45v10l-8.274.752A2.5 2.5 0 0 1 43 53.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L54 45Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 44 .445.223A2.813 2.813 0 0 1 54 46.738v6.524c0 1.065-.602 2.039-1.555 2.515L52 56"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 35V25l8.274-.752A2.5 2.5 0 0 1 17 26.738v6.524a2.5 2.5 0 0 1-2.726 2.49L6 35Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 36-.445-.223A2.813 2.813 0 0 1 6 33.262v-6.524c0-1.065.602-2.039 1.555-2.515L8 24"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 25v10l-8.274.752A2.5 2.5 0 0 1 43 33.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L54 25Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 24 .445.223A2.813 2.813 0 0 1 54 26.738v6.524c0 1.065-.602 2.039-1.555 2.515L52 36"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 55V45l8.274-.752A2.5 2.5 0 0 1 17 46.738v6.524a2.5 2.5 0 0 1-2.726 2.49L6 55Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 56-.445-.223A2.813 2.813 0 0 1 6 53.262v-6.524c0-1.065.602-2.039 1.555-2.515L8 44"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35 72H25l-.752-8.274A2.5 2.5 0 0 1 26.738 61h6.524a2.5 2.5 0 0 1 2.49 2.726L35 72Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m36 70-.223.445A2.813 2.813 0 0 1 33.262 72h-6.524a2.813 2.813 0 0 1-2.515-1.555L24 70"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25 8h10l.752 8.274A2.5 2.5 0 0 1 33.262 19h-6.524a2.5 2.5 0 0 1-2.49-2.726L25 8Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m24 10 .223-.445A2.813 2.813 0 0 1 26.738 8h6.524c1.065 0 2.039.602 2.515 1.555L36 10"
})));
SvgRectangle64C.viewBox = '0 0 60 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle64C);
export default ForwardRef;